// extracted by mini-css-extract-plugin
export var markdown = "_s3-0";
export var tableWrapper = "_s3-1";